import { render, staticRenderFns } from "./IntervalRule.vue?vue&type=template&id=c8c81f3a"
import script from "./IntervalRule.vue?vue&type=script&lang=js"
export * from "./IntervalRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports